import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import * as ROUTES from '@constants/routes';

import type { ObservationRecord } from '@models/observation';

import ObservationTracker from '../ObservationTracker/ObservationTracker';

const messages = defineMessages({
  title: {
    id: 'dashboardSleep.title',
    defaultMessage: 'Recent Sleep Measurements',
  },
  noMetrics: {
    id: 'dashboardSleep.noMetrics',
    defaultMessage:
      'To see sleep metrics here, connect a device to your VITALL account by clicking Connect Device below or from within the Health Devices section.',
  },
  viewAll: {
    id: 'dashboard.metrics',
    defaultMessage: 'View All',
  },
});

function Sleep({
  loading,
  observations,
}: {
  loading: boolean;
  observations: Record<string, ObservationRecord | null>;
}) {
  const { formatMessage } = useIntl();

  return (
    <ObservationTracker
      loading={loading}
      noData={formatMessage(messages.noMetrics)}
      observations={observations}
      route={ROUTES.SLEEP}
      title={formatMessage(messages.title)}
      viewAll={formatMessage(messages.viewAll)}
    />
  );
}

export default Sleep;
